import './Home.css';
import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { withTranslate } from 'react-redux-multilingual';
import { keyframes } from "@emotion/react";
import Zoom from 'react-medium-image-zoom'
import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Box from '@mui/material/Box';
import ChevronRightIcon from '@mui/icons-material/ChevronRight';
import Button from '@mui/material/Button';
import Divider from '@mui/material/Divider';

import FadeInSection from '../../blocks/FadeInSection/FadeInSection';
import Video from '../../blocks/Video/Video';

import BenifitsTime from '../../../libraries/Images/benefitsTime.svg';
import BenifitsMoney from '../../../libraries/Images/benefitsMoney.svg';
import BenifitsTask from '../../../libraries/Images/benefitsTask.svg';
import Step1 from '../../../libraries/Images/creatrobot1.png';
import Step2 from '../../../libraries/Images/creatrobot2.png';
import Step3 from '../../../libraries/Images/creatrobot3.png';
import Step4 from '../../../libraries/Images/creatrobot4.png';

import { 
    HiOutlineUser
    , HiCubeTransparent
    , HiOutlineColorSwatch
} from "react-icons/hi";

const dancing = keyframes`
    0 %  { transform: translateY(0px)},
    25%  { transform: translateY(20px) },
    50%  { transform: translateY(0px)},
    75%  { transform: translateY(20px) },
    100% { transform: translateY(0px) }
`;

function Home(props) {
    const { translate } = props;

    useEffect(() => {
        window.scrollTo({ top: 0, behavior: "smooth" });
    }, [])

    return (
        <div className='home'>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-1'>
                    <Container maxWidth="xl" sx={{ display: "flex", gap: 20, flexDirection: { xs: 'column', md: 'row' } }}>
                        <Box sx={{ display: { xs: "block", md: "flex" }, textAlign: { xs: "center", md: "left" } }}>
                            <FadeInSection>
                                <Typography variant="body1" gutterBottom component="p" sx={{ letterSpacing: "2px", textTransform: "uppercase", color: "#9CA3AF" }}>
                                    {translate('rpacloudssubtitle')}
                                </Typography>
                                <Typography variant="h2" gutterBottom component="h1" sx={{ fontWeight: "500", pt: 1, pb: 5 }}>
                                    {translate('rpacloudslogan')}
                                </Typography>
                                <Typography variant="body1" gutterBottom component="p" sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem" }}>
                                    {translate('rpaclouddescription')}
                                </Typography>
                                <Box sx={{ mt: 5, display: "flex", justifyContent: { xs: "center", md: "left" }, gap: 2 }}>
                                    <Button variant="contained" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/register/standard">
                                    {translate('tryforfree')}
                                    </Button>
                                    <Button variant="outlined" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/contact">
                                    {translate('contactsales')}
                                    </Button>
                                </Box>
                            </FadeInSection>
                        </Box>
                        <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                            <FadeInSection>
                                <Box sx={{ justifyContent: "center", display: { xs: 'none', md: 'block' } }}>
                                    <Video 
                                        width={747} 
                                        height={420} 
                                        url={'https://youtu.be/K1qWaqdVymM'}
                                        playing={true}
                                        loop={true}
                                        controls={false}
                                        muted={true}
                                        light={false}
                                    />
                                </Box>
                                <Box  sx={{ justifyContent: "center", display: { xs: 'block', md: 'none' } }}>
                                    <Video 
                                        width={356} 
                                        height={200} 
                                        url={'https://youtu.be/K1qWaqdVymM'}
                                        playing={true}
                                        loop={true}
                                        controls={false}
                                        muted={true}
                                        light={false}
                                    />
                                </Box>
                            </FadeInSection>
                        </Box>
                    </Container>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-2' sx={{ textAlign: { xs: "center", md: "left" }}}>
                    <Container maxWidth="xl" sx={{ display: "flex", gap: { xs: 10, md: 20 }, flexDirection: { xs: 'column', md: 'row' } }}>
                        {translate('highlightfeatures')?.map((item,  index) => (
                            <Box key={item.title} sx={{ width: "100%" }}>
                                {(index === 0) && <HiOutlineUser fontSize={30} />}
                                {(index === 1) && <HiCubeTransparent fontSize={30} />}
                                {(index === 2) && <HiOutlineColorSwatch fontSize={30} />}
                                <Typography variant="h5" component="p" gutterBottom sx={{ fontWeight: 600, my: 2 }}>{item.title}</Typography>
                                <Typography variant="body1" component="p"gutterBottom sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem" }}>{item.content}</Typography>
                            </Box>
                        ))}
                    </Container>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-3' sx={{ textAlign: { xs: "center", md: "left" }  }}>
                    <Container maxWidth="xl">
                        <Typography variant="h3" gutterBottom component="h3" sx={{ fontWeight: "500", pt: 5, pb: 1, textAlign: "center" }}>
                            {translate('howtouserpacloud')}
                        </Typography>
                        <Typography variant="body1" component="p" gutterBottom sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem", textAlign: "center", pb: 5 }}>
                            {translate('howtouserpaclouddescription')}
                        </Typography>
                        <Box sx={{ display: "flex", gap: { xs: 1, md: 20 }, flexDirection: { xs: 'column-reverse', md: 'row' }, py: { xs: 2, md: 10 }, px: { xs: 2, md: 20 } }}>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, animation: `${dancing} 5s infinite ease` }}>
                                <Zoom >
                                    <img width="100%"  src={Step1} style={{ borderRadius: "16px" }} />
                                </Zoom>
                            </Box>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                <Typography variant="body1" gutterBottom component="p" sx={{ letterSpacing: "2px", textTransform: "uppercase", color: "#9CA3AF", pb: 2 }}>
                                    01
                                </Typography>
                                <Typography variant="h5" gutterBottom component="h4" sx={{ fontWeight: "bold", textAlign: "left", pb: 2 }}>
                                {translate('createyourrobot')}
                                </Typography>
                                <Typography  variant="body1" gutterBottom component="div" sx={{ color: "#586978", textAlign: "left", fontSize: "1.2rem", lineHeight: "2rem" }}>
                                    {translate('createyourrobotdescription')}
                                </Typography>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: { xs: 1, md: 20 }, flexDirection: { xs: 'column', md: 'row' }, py: { xs: 2, md: 10 }, px: { xs: 2, md: 20 } }}>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                <Typography variant="body1" gutterBottom component="p" sx={{ letterSpacing: "2px", textTransform: "uppercase", color: "#9CA3AF", pb: 2 }}>
                                    02
                                </Typography>
                                <Typography variant="h5" gutterBottom component="h4" sx={{ fontWeight: "bold", textAlign: "left", pb: 2 }}>
                                {translate('testtherobot')}
                                </Typography>
                                <Typography  variant="body1" gutterBottom component="div" sx={{ color: "#586978", textAlign: "left", fontSize: "1.2rem", lineHeight: "2rem" }}>
                                    {translate('testtherobotdescription')}
                                </Typography>
                            </Box>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, animation: `${dancing} 5s infinite ease` }}>
                                <Zoom>
                                    <img width="100%"  src={Step2} style={{ borderRadius: "16px" }}/>
                                </Zoom>
                            </Box>
                        </Box>
                        <Box sx={{ display: "flex", gap: { xs: 1, md: 20 }, flexDirection: { xs: 'column-reverse', md: 'row' }, py: { xs: 2, md: 10 }, px: { xs: 2, md: 20 } }}>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, animation: `${dancing} 5s infinite ease` }}>
                                <Zoom>
                                    <img width="100%"  src={Step3} style={{ borderRadius: "16px" }}/>
                                </Zoom>
                            </Box>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                <Typography variant="body1" gutterBottom component="p" sx={{ letterSpacing: "2px", textTransform: "uppercase", color: "#9CA3AF", pb: 2 }}>
                                    03
                                </Typography>
                                <Typography variant="h5" gutterBottom component="h4" sx={{ fontWeight: "bold", textAlign: "left", pb: 2 }}>
                                {translate('settheschedule')}
                                </Typography>
                                <Typography  variant="body1" gutterBottom component="div" sx={{ color: "#586978", textAlign: "left", fontSize: "1.2rem", lineHeight: "2rem" }}>
                                    {translate('setthescheduledescription')}
                                </Typography>
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-4' sx={{ textAlign: { xs: "center", md: "left" }}}>
                    <Container maxWidth="xl">
                        <Typography variant="h3" gutterBottom component="h3" sx={{ fontWeight: "500", pt: 5, pb: 1, textAlign: "center" }}>
                            {translate('benefitsofusingrpacloud')}
                        </Typography>
                        <Typography variant="body1"  component="p"gutterBottom sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem", textAlign: "center", pb: 10 }}>
                            {translate('benefitsofusingrpaclouddescription')}
                        </Typography>
                        <Box sx={{ display: "flex", gap: 20, flexDirection: { xs: 'column', md: 'row' }}}>
                            <Box sx={{ width: "100%", textAlign: "center"  }}>
                                <FadeInSection>
                                    <img height={120} src={BenifitsTime}/>
                                    <Typography variant="body1" component="p" gutterBottom sx={{ color: "#586978", fontWeight: "bold", mt: 4 }}>
                                        {translate('savetime')}
                                    </Typography>
                                </FadeInSection>
                            </Box>
                            <Box sx={{ width: "100%", textAlign: "center"  }}>
                                <FadeInSection>
                                    <img height={120} src={BenifitsMoney}/>
                                    <Typography variant="body1" component="p" gutterBottom sx={{ color: "#586978", fontWeight: "bold", mt: 4 }}>
                                        {translate('costefficiency')}
                                    </Typography>
                                </FadeInSection>
                            </Box>
                            <Box sx={{ width: "100%", textAlign: "center" }}>
                                <FadeInSection>
                                    <img height={120} src={BenifitsTask}/>
                                    <Typography variant="body1" component="p" gutterBottom sx={{ color: "#586978", fontWeight: "bold", mt: 4 }}>
                                        {translate('accuratetask')}
                                    </Typography>
                                </FadeInSection>
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-5' sx={{ textAlign: { xs: "center", md: "left" }}}>
                    <Container maxWidth="xl">
                        <Box sx={{ display: "flex", gap: { xs: 2, md: 20 }, flexDirection: { xs: 'column', md: 'row' }, pt: { xs: 1, md: 10 }, px: { xs: 2, md: 20 } }}>
                            <Box sx={{ width: { xs: "100%", md: "50%" }, display: "flex", flexDirection: "column", justifyContent: "center" }}>
                                <Typography variant="h5" gutterBottom component="h4" sx={{ fontWeight: "bold", textAlign: "left", pb: 2 }}>
                                {translate('uniquefeature')}
                                </Typography>
                                <Typography  variant="body1" gutterBottom component="div" sx={{ color: "#586978", textAlign: "left", fontSize: "1.2rem", lineHeight: "2rem", pb: 2 }}>
                                    {translate('uniquefeaturedescription')}
                                </Typography>
                                <Box>
                                    <Button variant="outlined" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/feature">
                                        {translate('feature')}
                                    </Button>
                                </Box>
                            </Box>
                            <Box sx={{ width: { xs: "100%", md: "50%" } }}>
                                <Zoom>
                                    <img width="100%"  src={Step4} />
                                </Zoom>
                            </Box>
                        </Box>
                    </Container>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-6' sx={{ textAlign: { xs: "center", md: "left" }}}>
                    <Container maxWidth="xl">
                        <Typography variant="h3" gutterBottom component="h3" sx={{ fontWeight: "500", pt: 5, pb: 1, textAlign: "center" }}>
                            {translate('frequentlyaskedquestion')}
                        </Typography>
                        {translate('frequentlyaskedquestions')?.map((item,  index) => (
                        <Box key={item.question} sx={{ pt: { xs: 1, md: 5 }, px: { xs: 2, md: 50 } }}>
                            <Typography variant="h5" gutterBottom component="h4" sx={{ fontWeight: "bold", textAlign: "left", pb: 2 }}>
                            {item.question}
                            </Typography>
                            <Typography variant="body1" gutterBottom component="p" sx={{ color: "#586978", textAlign: "left", fontSize: "1.2rem", lineHeight: "2rem", pb: 2 }}>
                            {item.answer}
                            </Typography>
                            <Divider />
                        </Box>))}
                    </Container>
                </Box>
            </Container>
            <Container maxWidth="100%" sx={{ padding: "0px !important" }}>
                <Box className='section-7' sx={{ textAlign: { xs: "center", md: "left" }}}>
                    <Container maxWidth="xl">
                        <Typography variant="h3" gutterBottom component="h3" sx={{ fontWeight: "500", pt: 5, pb: 1, textAlign: "center" }}>
                        {translate('footerslogan')}
                        </Typography>
                        <Typography variant="body1" gutterBottom component="p" sx={{ color: "#586978", fontSize: "1.2rem", lineHeight: "2rem", pb: 2 }}>
                        {translate('footerscription')}
                        </Typography>
                        <Box>
                            <Button variant="contained" color="success" endIcon={<ChevronRightIcon />} component={Link} to="/feature">
                                {translate('getstarted')}
                            </Button>
                        </Box>
                    </Container>
                </Box>
            </Container>
        </div>
    );
}
export default withTranslate(Home);